import styled from "styled-components";

export const VoucherCardSideDefaultBox = styled.div<{backgroundImageUrl: string; backSideShown: boolean;}>`
    position: absolute;
    display: flex;
    flex-direction: column;

    background-image: url("${props => props.backgroundImageUrl}");
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    color: ${({ theme }) => theme.colors.textContrast};
    width: 100%;
    box-sizing: border-box;
    height: 100%;
    transition: transform 0.6s;
    backface-visibility: hidden;
    padding: 10px 20px 20px 20px;
`;
